<template>
    <vx-card title="Signs">
        <div id="viewSignLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true"
                @search="handleSearch"
                @change-page="handleChangePage"
                @sort="handleSort"
                v-model="selected"
            
                :data="signs">

                <template slot="header">
                    <div class="flex flex-wrap items-center w-full mb-2">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addSign">Add a Sign</vs-button>
                        <vs-button class="ml-2" color="primary" type="filled" icon-pack="feather" icon="icon-layers" @click="manageSigns">Sign categories</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th >Name</vs-th>
                    <vs-th >Image</vs-th>
                    <!-- <vs-th >Description</vs-th> -->
                    <vs-th >Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                            {{data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].image">
                            <img width="50" :src="data[indextr].image_path">
                        </vs-td>
                       <!--  <vs-td :data="data[indextr].description" style="max-width: 500px;max-height: 300px;">
                            <div v-html="data[indextr].description" style="max-width: 500px;max-height: 300px;"></div>
                        </vs-td> -->
                        <vs-td>
                            <vs-row>
                                <vs-button @click="editSign(data[indextr])" class="mr-2" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deleteSign(data[indextr])" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup class="categories_popup" classContent="popup-example h-full" title="Sign categories" :active.sync="signsPopUp" fullscreen>
                <sign-category></sign-category>
            </vs-popup>

            <vs-popup  classContent="popup-example h-full" title="Add Sign" :active.sync="activePromptAddSign">
                <div id="createSignLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="addSignForm">
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" label="Sign name" name="name" v-model="create_sign.name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addSignForm.name')">{{ errors.first('addSignForm.name') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full mb-2">
                               <VueFileAgent
                                name="image"
                                ref="vueFileAgendsdt"
                                v-validate="'required'"
                                :theme="'list'"
                                :multiple="false"
                                :deletable="true"
                                :meta="true"
                                :compact="true"
                                :accept="'image/*'"
                                :maxSize="'5MB'"
                                :helpText="'Choose Sign Image'"
                                :errorText="{
                                  type: 'Invalid file type. Only image Allowed',
                                  size: 'Files should not exceed 5MB in size',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="image"
                              ></VueFileAgent>
                              <span class="text-danger text-sm" v-show="errors.has('addSignForm.image')">{{ errors.first('addSignForm.image') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full">
                                <span>Sign categories</span>
                                <treeselect v-validate="'required'" name="categories" v-model="create_sign.categories" :multiple="true" :options="sign_categories_options" />
                                <span class="text-danger text-sm" v-show="errors.has('addSignForm.categories')">{{ errors.first('addSignForm.categories') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full">
                                Description
                                <quill-editor v-model="create_sign.description"></quill-editor>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="createSign()" color="primary" type="filled">Save Sign</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <vs-popup  classContent="popup-example h-full" title="Edit Sign" :active.sync="activePromptEditSign">
                <div id="editSignLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="editSignForm">
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" label="Sign name" name="name" v-model="update_sign.name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('editSignForm.name')">{{ errors.first('editSignForm.name') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full mb-2">
                               <VueFileAgent
                                name="image"
                                ref="vueFileAgendsdt"
                                v-validate="''"
                                :theme="'list'"
                                :multiple="false"
                                :deletable="true"
                                :meta="true"
                                :compact="true"
                                :accept="'image/*'"
                                :maxSize="'5MB'"
                                :helpText="'Choose Sign Image'"
                                :errorText="{
                                  type: 'Invalid file type. Only image Allowed',
                                  size: 'Files should not exceed 5MB in size',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="image"
                              ></VueFileAgent>
                              <span class="text-danger text-sm" v-show="errors.has('editSignForm.image')">{{ errors.first('editSignForm.image') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full">
                                <span>Sign categories</span>
                                <treeselect v-validate="'required'" name="categories" v-model="update_sign.categories" :multiple="true" :options="sign_categories_options" />
                                <span class="text-danger text-sm" v-show="errors.has('editSignForm.categories')">{{ errors.first('editSignForm.categories') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full">
                                Description
                                <quill-editor v-model="update_sign.description"></quill-editor>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="updateSign()" color="primary" type="filled">Update Sign</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <div class="vx-row mt-base">
                <div class="vx-col w-full mb-2">
                    <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import SignCategory from "./SignCategories.vue"

export default {
    components: {
        vSelect,
        Treeselect,
        quillEditor,
        SignCategory,
    },
    data() {
        return {
            selected:[],
            key : null, 
            active : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            signs: [],
            deleteSignData : null,
            selected_place_name : null,
            selected_place_location : null,
            selected_place_type : "all",
            place_types : [
                { id : 'all', label : 'All' },
                { id : 'place', label : 'Sign' },
                { id : 'event', label : 'Event' },
                { id : 'tip', label : 'Tip' },
            ],
            activePromptAddSign : false,
            activePromptEditSign : false,
            image : [],
            fileRecordsForUpload: [],
            create_sign : {
                name : null,
                categories : [],
                description : null,
                status : true,
            },
            create_sign : {
                name : null,
                categories : [],
                description : null,
                status : true,
            },
            update_sign : {
                id : null,
                name : null,
                categories : [],
                description : null,
                status : true,
            },
            signsPopUp : false

        }
    },
    watch: {
        currentPage(val) {
            this.searchSigns()
        }
    },
    async mounted() {
        await this.viewSigns() 
        this.signs = this.$store.state.questionManagement.signs
    },
    computed: {
        sign_categories_options(){
            let signCategories = this.$store.state.questionManagement.sign_categories
            // console.log(signCategories)
            let signCategoriesData = []

            signCategories.forEach(function(entry, key) {
                signCategoriesData.push({
                    id : entry.id,
                    title : entry.name,
                    label : entry.name,
                })
            });

            return signCategoriesData
        },
    },
    methods: {
        manageSigns(){
            this.signsPopUp = true
        },
        redirectToAppPath(path){
            window.open(path, "_blank");
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
            // queued file, not yet uploaded. Just remove from the arrays
              this.fileRecordsForUpload.splice(i, 1);
              var k = this.image.indexOf(fileRecord);
              if (k !== -1) this.image.splice(k, 1);
            } else {
              this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        addSign() {
            this.image = [];
            this.fileRecordsForUpload = [];
            this.activePromptAddSign = true;
        },
        createSign(){
            this.$validator.validateAll('addSignForm').then(result => {
                if (result) this.createSignApi()
            })
        },
        createSignApi(){
            var self = this 
            this.$vs.loading({
              container: '#createSignLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('name', this.create_sign.name);
            data.append('description', this.create_sign.description);
            // data.append('categories[]', this.create_sign.categories);

            if(this.image.length) data.append('image', this.image[0].file);
            if(this.create_sign.categories.length){
                for (let i = 0; i < this.create_sign.categories.length; i++){
                    data.append('categories[]', this.create_sign.categories[i]);
                }
            }

            this.$store.dispatch("questionManagement/createSign", data)
                .then(res => { 
                    this.$vs.loading.close('#createSignLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.fileRecordsForUpload = [];
                    this.activePromptAddSign = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#createSignLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "addSignForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        editSign(sign) {
            this.update_sign = sign;
            this.image = [];
            this.fileRecordsForUpload = [];

            let signIds = [];

            if(sign.category && sign.category.length){
                for (let i = 0; i < sign.category.length; i++){
                    signIds.push(sign.category[i].id)
                }
            }

            this.update_sign.categories = signIds
            this.activePromptEditSign = true
        },
        updateSign(){
            this.$validator.validateAll('editSignForm').then(result => {
                if (result) this.updateSignApi()
            })
        },
        updateSignApi(){
            var self = this 
            this.$vs.loading({
              container: '#editSignLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('id', this.update_sign.id);
            data.append('name', this.update_sign.name);
            data.append('description', this.update_sign.description);
            // data.append('categories[]', this.update_sign.categories);

            if(this.image.length) data.append('image', this.image[0].file);
            if(this.update_sign.categories.length){
                for (let i = 0; i < this.update_sign.categories.length; i++){
                    data.append('categories[]', this.update_sign.categories[i]);
                }
            }

            this.$store.dispatch("questionManagement/updateSign", data)
                .then(res => { 
                    this.$vs.loading.close('#editSignLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.fileRecordsForUpload = [];
                    this.activePromptEditSign = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#editSignLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "editSignForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteSign(place) {
            this.deleteSignData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this data ?',
                accept: this.acceptDeleteSign
            })
        },
        acceptDeleteSign() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteSign", { id : this.deleteSignData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Sign deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        
        
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchSigns()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchSigns()
            }
        },
        async searchSigns() {
            var self = this
            this.$vs.loading({
                container: '#viewSignLoadingDiv',
                scale: 0.6
            })

            let data = { 
                name : this.selected_place_name, 
                location : this.selected_place_location, 
                sort : this.key, 
                sort_key : this.active, 
                page : this.currentPage,
                place_type : this.selected_place_type,
            }

            await this.$store.dispatch("questionManagement/viewSign", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewSignLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewSignLoadingDiv > .con-vs-loading')
                })

                this.signs = this.$store.state.questionManagement.signs
        },
        async viewSigns() {
            var self = this

            await this.$store.dispatch("questionManagement/viewSign", {page : this.currentPage})
                .then(res => { 
                    this.totalPage = res.data.last_page
                })

            this.signs = this.$store.state.questionManagement.signs
        },
    },
    async created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        await this.$store.dispatch("questionManagement/viewSignCategoryWithOutPagi")

        
    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.vs-con-textarea{
    height: 400px;
}

.vs-textarea {
    height: 100%;
}

.categories_popup .vs-popup{
    width: 700px !important;
}

</style>

